var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('header',[_c('div',{attrs:{"id":"headerContainer"}},[_c('img',{attrs:{"src":"tebucks_logo.png","alt":"Tenmo Logo"}})])])
}]

export { render, staticRenderFns }